/**
 * @generated SignedSource<<ed8b5de75ebbeb144021c7c45b21dfd7>>
 * @relayHash f1b7f7b512da9e0aa08b55196721bc8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1442e789c5171157bf882e3c96a4fe1dbfaf4171cde4fc7ff6761b6ca4e0d511

import type { ConcreteRequest, Query } from 'relay-runtime';
export type batchIsEditableInIssueViewFactoryQuery$variables = {
  first?: number | null | undefined;
  ids: ReadonlyArray<string>;
};
export type batchIsEditableInIssueViewFactoryQuery$data = {
  readonly jira: {
    readonly issueFieldsByIds: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __id: string;
          readonly id: string;
          readonly isEditableInIssueView: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type batchIsEditableInIssueViewFactoryQuery = {
  response: batchIsEditableInIssueViewFactoryQuery$data;
  variables: batchIsEditableInIssueViewFactoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ids"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "isEditableInIssueView"
},
v5 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "batchIsEditableInIssueViewFactoryQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "issueFieldsByIds",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "batchIsEditableInIssueViewFactoryQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "issueFieldsByIds",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1442e789c5171157bf882e3c96a4fe1dbfaf4171cde4fc7ff6761b6ca4e0d511",
    "metadata": {},
    "name": "batchIsEditableInIssueViewFactoryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c26db256f9ee6c88ad5dbf683c6b0507";

export default node;
